import './App.css';

import React, { useState, useEffect, audio, Component } from 'react';

import socketIOClient from "socket.io-client";

import 'bootstrap/dist/css/bootstrap.min.css';

import Container from 'react-bootstrap/Container';

import {
  DndContext,
  closestCenter,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors
} from "@dnd-kit/core";

import {
  arrayMove,
  SortableContext,
  horizontalListSortingStrategy,
  verticalListSortingStrategy
} from "@dnd-kit/sortable";

import { SortableItem } from './SortableItem';

const socket = socketIOClient("https://fifth-track-club-server.onrender.com");

socket.on("connect", () => {
  console.log("Connected to the server: " + socket.id);
});

socket.on("disconnect", () => {
  console.log("Disconnected from the server");
});

let buttonName;

let defaultArray;

let sortedArray;

let trackDetails;

let sortingStrategy = horizontalListSortingStrategy;

export default function App() {
  const mouseSensor = useSensor(MouseSensor);
  const touchSensor = useSensor(TouchSensor);

  const sensors = useSensors(
    mouseSensor,
    touchSensor,
  );

  const [isMounted, setIsMounted] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const [isCorrect1, setIsCorrect1] = useState(null);
  const [isCorrect2, setIsCorrect2] = useState(null);
  const [isCorrect3, setIsCorrect3] = useState(null);
  const [isCorrect4, setIsCorrect4] = useState(null);
  const [isCorrect5, setIsCorrect5] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const [isDone, setIsDone] = useState(false);
    
  const [track1, setTrack1] = useState(null);
  const [track2, setTrack2] = useState(null);
  const [track3, setTrack3] = useState(null);
  const [track4, setTrack4] = useState(null);
  const [track5, setTrack5] = useState(null);

  const [artistImage, setArtistImage] = useState(null);
  const [artistName, setArtistName] = useState(null);

  const [languages, setLanguages ] = useState(
    [<div key='1' id='card1' pop='temp'></div>,
    <div key='2' id='card2' pop='temp'></div>,
    <div key='3' id='card3' pop='temp'></div>,
    <div key='4' id='card4' pop='temp'></div>,
    <div key='5' id='card5' pop='temp'></div>]);

  const [score, setScore] = useState(0);

  const [disabledButton, setDisabledButton] = useState(false);
  const [round, setRound] = useState(0);

  const highScore = localStorage.getItem('HS');

  const [templateImages, setTemplateImages] = useState({genre1: '', genre2: '', genre3: ''});

  socket.on('message', (data) => {

    const jsonData = data;

    setArtistImage(jsonData['image']);
    setArtistName(jsonData['name']);

    setRound(round + 1);

    createObject(jsonData);
  });

  socket.on('templateArtistImages', (data) => {
    const jsonData = data;
    setTemplateImages({genre1: jsonData[0], genre2: jsonData[1], genre3: jsonData[2]});
  });

  function createObject(jsonData){
    let namesList = jsonData[0];
    let imagesList = jsonData[1];
    let popList = jsonData[2];
    let prevList = jsonData[3];

    defaultArray = [
      popList['popularity1'],
      popList['popularity2'],
      popList['popularity3'],
      popList['popularity4'],
      popList['popularity5']
    ]

    defaultArray.sort(function(a, b) {
      return a - b;
    });

    let trackNames = {
      name1: namesList['name1'],
      name2: namesList['name2'],
      name3: namesList['name3'],
      name4: namesList['name4'],
      name5: namesList['name5'],
    }

    let trackImages = {
      image1: imagesList['image1'],
      image2: imagesList['image2'],
      image3: imagesList['image3'],
      image4: imagesList['image4'],
      image5: imagesList['image5']
    }

    let trackPop = {
      pop1: popList['popularity1'],
      pop2: popList['popularity2'],
      pop3: popList['popularity3'],
      pop4: popList['popularity4'],
      pop5: popList['popularity5']
    }

    let trackPrev = {
      prev1: prevList['preview1'],
      prev2: prevList['preview2'],
      prev3: prevList['preview3'],
      prev4: prevList['preview4'],
      prev5: prevList['preview5']
    }

    setTrack1({ name: trackNames['name1'], image: trackImages['image1'], preview: trackPrev['prev1'], popularity: trackPop['pop1'] });
    setTrack2({ name: trackNames['name2'], image: trackImages['image2'], preview: trackPrev['prev2'], popularity: trackPop['pop2'] });
    setTrack3({ name: trackNames['name3'], image: trackImages['image3'], preview: trackPrev['prev3'], popularity: trackPop['pop3'] });
    setTrack4({ name: trackNames['name4'], image: trackImages['image4'], preview: trackPrev['prev4'], popularity: trackPop['pop4'] });
    setTrack5({ name: trackNames['name5'], image: trackImages['image5'], preview: trackPrev['prev5'], popularity: trackPop['pop5'] });

    setIsPlaying(true);
    setIsLoading(false);
  }

  useEffect(() => {
    if (isMounted === true && !isDone){
      //Instead of long complicated ternary conditions, just set the languages in handlemove using the trackDetails array
      setLanguages([
        <div key='1' id='card1' pop={ track1['popularity'] } name={ track1['name'] } image={ track1['image'] } preview={ track1['preview'] }>
        <img id='cardImage' src={ track1['image'] } alt='Track 2 Cover Art'/>
        <p id='cardName'>{ track1['name'] }</p>
        <audio src={ track1['preview'] } controls />
      </div>,
      <div key='2' id='card2' pop={ track2['popularity'] } name={ track2['name'] } image={ track2['image'] } preview={ track2['preview'] }>
        <img id='cardImage' src={ track2['image'] } alt='Track 2 Cover Art'/>
        <p id='cardName'>{ track2['name'] }</p>
        <audio src={ track2['preview'] } controls />
      </div>,
      <div key='3' id='card3' pop={ track3['popularity'] } name={ track3['name'] } image={ track3['image'] } preview={ track3['preview'] }>
        <img id='cardImage' src={ track3['image'] } alt='Track 3 Cover Art'/>
        <p id='cardName'>{ track3['name'] }</p>
        <audio src={ track3['preview'] } controls />
      </div>,
      <div key='4' id='card4' pop={ track4['popularity'] } name={ track4['name'] } image={ track4['image'] } preview={ track4['preview'] }>
        <img id='cardImage' src={ track4['image'] } alt='Track 4 Cover Art'/>
        <p id='cardName'>{ track4['name'] }</p>
        <audio src={ track4['preview'] } controls />
      </div>,
      <div key='5' id='card5' pop={ track5['popularity'] } name={ track5['name'] } image={ track5['image'] } preview={ track5['preview'] }>
        <img id='cardImage' src={ track5['image'] } alt='Track 5 Cover Art'/>
        <p id='cardName'>{ track5['name'] }</p>
        <audio src={ track5['preview'] } controls />
      </div>]);

      if (window.screen.width > window.screen.height) {
        sortingStrategy = horizontalListSortingStrategy;
      } else {
        sortingStrategy = verticalListSortingStrategy;
      }

      setDisabledButton(false);
    }
    else{
      
      if (window.screen.width > window.screen.height) {
        sortingStrategy = horizontalListSortingStrategy;
      } else {
        sortingStrategy = verticalListSortingStrategy;
      }
      setIsMounted(true);
    }
  }, [track1, track2, track3, track4, track5, isCorrect1, isCorrect2, isCorrect3, isCorrect4, isCorrect5]); // this effect will run whenever trackNames changes after the inital render


  const postData = (buttonName) =>{
    socket.emit('payload', buttonName);
  }

  const handleClick = event => {
    setIsLoading(true);
    event.preventDefault();
    buttonName = event.currentTarget.name;
    console.log(buttonName);
    postData(buttonName);
  };

  const handleCheck = event => {
    setIsLoading(true);
    if (round <= 5) {
      setDisabledButton(true);
      event.preventDefault();
      buttonName = event.currentTarget.name;
      console.log(buttonName);

      setTimeout(function () {
        setIsLoading(false);
        setIsDone(false);
        socket.emit('payload', buttonName);
      }, 1000);
    }
    else {
      if (score < highScore) {
        window.location.reload(false);
      }
      else {
        localStorage.setItem('HS', score);
        window.location.reload(false);
      }
    }
  }

  const handleMove = event => {
    event.preventDefault();

    let tempScore = score;

    if (sortingStrategy === horizontalListSortingStrategy) {

    }
    else {
      sortedArray.reverse();
    }

    for (let i = 0; i < 5; i++) {
      if (defaultArray[i] !== sortedArray[i]) {
        console.log('Incorrect')
        //Needs to set them to true or false for every i instead of all at once
        switch (i) {
          case 0:
            setIsCorrect1(false);
            console.log(isCorrect1);
            break;
          case 1:
            setIsCorrect2(false);
            console.log(isCorrect2);
            break;
          case 2:
            setIsCorrect3(false);
            console.log(isCorrect3);
            break;
          case 3:
            setIsCorrect4(false);
            console.log(isCorrect4);
            break;
          case 4:
            setIsCorrect5(false);
            console.log(isCorrect5);
            break;
        }
      }
      else {
        console.log('Correct');
        tempScore+=20;
        setScore(tempScore);
        switch (i) {
          case 0:
            setIsCorrect1(true);
            console.log(isCorrect1);
            break;
          case 1:
            setIsCorrect2(true);
            console.log(isCorrect2);
            break;
          case 2:
            setIsCorrect3(true);
            console.log(isCorrect3);
            break;
          case 3:
            setIsCorrect4(true);
            console.log(isCorrect4);
            break;
          case 4:
            setIsCorrect5(true);
            console.log(isCorrect5);
            break;
        }
      }
    }

    setIsDone(true);
  }

  useEffect (() => {
    if (isDone) {
    setLanguages([
      <div key='1' id='card1' pop={ track1['popularity'] } name={ track1['name'] } image={ track1['image'] } preview={ track1['preview'] }>
      <img id='cardImage' src={ trackDetails[0][1] } alt='Track 1 Cover Art'/>
      <p id='cardName'>{ trackDetails[0][0] }</p>
      <audio src={ trackDetails[0][2] } controls />
      <div>
        { isCorrect1 ? (
          <>
          <div id='complete'>
            <img id='correct' src='/images/correct.png'/>
            <p id='cardName'>Popularity: {sortedArray[0]}</p>
          </div>
          </>
        ) : (
          <>
          <div id='complete'>
            <img id='correct' src='/images/incorrect.png'/>
            <p id='cardName'>Popularity: {sortedArray[0]}</p>
          </div>
          </>
        )}
      </div>
    </div>,
    <div key='2' id='card2' pop={ track2['popularity'] } name={ track2['name'] } image={ track2['image'] } preview={ track2['preview'] }>
      <img id='cardImage' src={ trackDetails[1][1] } alt='Track 2 Cover Art'/>
      <p id='cardName'>{ trackDetails[1][0] }</p>
      <audio src={ trackDetails[1][2] } controls />
      <div>
        { isCorrect2 ? (
          <>
          <div id='complete'>
            <img id='correct' src='/images/correct.png'/>
            <p id='cardName'>Popularity: {sortedArray[1]}</p>
          </div>
          </>
        ) : (
          <>
          <div id='complete'>
            <img id='correct' src='/images/incorrect.png'/>
            <p id='cardName'>Popularity: {sortedArray[1]}</p>
          </div>
          </>
        )}
      </div>
    </div>,
    <div key='3' id='card3' pop={ track3['popularity'] } name={ track3['name'] } image={ track3['image'] } preview={ track3['preview'] }>
      <img id='cardImage' src={ trackDetails[2][1]} alt='Track 3 Cover Art'/>
      <p id='cardName'>{ trackDetails[2][0] }</p>
      <audio src={ trackDetails[2][2] } controls />
      <div>
        { isCorrect3 ? (
          <>
          <div id='complete'>
            <img id='correct' src='/images/correct.png'/>
            <p id='cardName'>Popularity: {sortedArray[2]}</p>
          </div>
          </>
        ) : (
          <>
          <div id='complete'>
            <img id='correct' src='/images/incorrect.png'/>
            <p id='cardName'>Popularity: {sortedArray[2]}</p>
          </div>
          </>
        )}
      </div>
    </div>,
    <div key='4' id='card4' pop={ track4['popularity'] } name={ track4['name'] } image={ track4['image'] } preview={ track4['preview'] }>
      <img id='cardImage' src={ trackDetails[3][1] } alt='Track 4 Cover Art'/>
      <p id='cardName'>{ trackDetails[3][0] }</p>
      <audio src={ trackDetails[3][2] } controls />
      <div>
        { isCorrect4 ? (
          <>
          <div id='complete'>
            <img id='correct' src='/images/correct.png'/>
            <p id='cardName'>Popularity: {sortedArray[3]}</p>
          </div>
          </>
        ) : (
          <>
          <div id='complete'>
            <img id='correct' src='/images/incorrect.png'/>
            <p id='cardName'>Popularity: {sortedArray[3]}</p>
          </div>
          </>
        )}
      </div>
    </div>,
    <div key='5' id='card5' pop={ track5['popularity'] } name={ track5['name'] } image={ track5['image'] } preview={ track5['preview'] }>
      <img id='cardImage' src={ trackDetails[4][1] } alt='Track 5 Cover Art'/>
      <p id='cardName'>{ trackDetails[4][0] }</p>
      <audio src={ trackDetails[4][2] } controls />
      <div>
        { isCorrect5 ? (
          <>
          <div id='complete'>
            <img id='correct' src='/images/correct.png'/>
            <p id='cardName'>Popularity: {sortedArray[4]}</p>
          </div>
          </>
        ) : (
          <>
          <div id='complete'>
            <img id='correct' src='/images/incorrect.png'/>
            <p id='cardName'>Popularity: {sortedArray[4]}</p>
          </div>
          </>
        )}
      </div>
    </div>]);
    }
  },[isCorrect1, isCorrect2, isCorrect3, isCorrect4, isCorrect5]);

  return (
    <div>
      <div id='homeContainer'>
      { isPlaying ? (
          null
        ) : ( <>
          <div id='topElements'>
            { isLoading ? (
              <>
                <div class='loadingElements'>
                  <div class="loader"></div>
                  <div class='loadScreen'></div>
                </div>
              </>
            ) : (
              null
            )}

            <div id='title'>
              <h1>Fifth Track Club</h1>
              <a href='https://elliotminns.com/' style={{'marginLeft' : '0.3vmax'}}><h8>By Elliot Minns - Version 1.1</h8></a>
            </div>
              <div id='buttons'>
                <div id="button1">
                  <button name="rap" class='button' onClick={handleClick}><img id='buttonImage' src='images/kendrick.png'/><p id='p2'>Rap</p></button>
                </div>

                <div id="button1">
                  <button name="pop" class='button' onClick={handleClick}><img id='buttonImage'src='images/taylor.png'/><p id='p2'>Pop</p></button>
                </div>

                <div id="button1">
                  <button name="EDM" class='button' onClick={handleClick}><img id='buttonImage' src='images/fred.png'/><p id='p2'>Dance</p></button>
                </div>
              </div>
          </div>

          <div id='bottomElements'>
            <div id='highScore' class='lsHigh'>
              <h2>High Score: {highScore}</h2>
            </div>
            
            <div class='myDiv' id='questionMark'>
              <img class='htpImg' src={"/images/question-mark.png"} alt="How To Play"/>
            </div>
            <div class='hide'>
              <h5>How To Play</h5>
              <p id='htpText'>Try to sort the tracks in order of popularity from lowest to highest. The popularity matrix is calculated by Spotify using a number of parameters, including number of streams and how often the track is currently being streamed. A number of points will be granted depending on how close your order is to that of the correct order. The goal is to get the highest number of points possible.</p>
            </div>
          </div>
          </> )}
      </div>

      <div>
      { isPlaying ? (
        <>
        <div id='playingTitle'>
          <h1>Fifth Track Club</h1>
        </div>
        <div style={{'zIndex': '3'}}>
          <h2 id='score'>Artist: {artistName} / Score: {score} / Round: {round}</h2>
          <h4 id='high'>Highest</h4>
        </div>

        <div id='sortableWrapper'>
          <DndContext style={{'z-index': '2', 'height': '1rem'}}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
            autoScroll={false}
            sensors={sensors}
            >
            <Container className="p-3" align="center">
              <SortableContext items={languages} strategy={sortingStrategy}>
                {languages.map(language => <SortableItem style={{'height': '-50px', 'z-position' : '1'}} key={language.key} id={language} pop={language.pop}/>, trackDetails = [[languages[0]['props']['name'], languages[0]['props']['image'], languages[0]['props']['preview']], [languages[1]['props']['name'], languages[1]['props']['image'], languages[1]['props']['preview']], [languages[2]['props']['name'], languages[2]['props']['image'], languages[2]['props']['preview']], [languages[3]['props']['name'], languages[3]['props']['image'], languages[3]['props']['preview']], [languages[4]['props']['name'], languages[4]['props']['image'], languages[4]['props']['preview']]], sortedArray = [languages[0]['props']['pop'], languages[1]['props']['pop'], languages[2]['props']['pop'], languages[3]['props']['pop'], languages[4]['props']['pop']], console.log(sortedArray))}
              </SortableContext>
            </Container>
          </DndContext>
          <h4 id='low' class='lsLow'>Lowest</h4>
        </div>

        <div id='confirmDiv'>
          { isDone ? (
                <>
                  <button id="confirm" disabled={disabledButton} name={buttonName} onClick={handleCheck}><img id='confirmImg' src={"/images/next.png"} alt="Confirm Sorted Order" /></button>
                </>
              ) : (
                <>
                  <button id="confirm" disabled={disabledButton} name={buttonName} onClick={handleMove}><img id='confirmImg' src={"/images/tick.png"} alt="Confirm Sorted Order" /></button>
                </>
              )}
          
        </div>
        

        <div class='myDiv2' id='questionMark'>
          <img class='htpImg2' src={"/images/question-mark.png"} alt="How To Play"/>
        </div>

         <div class='hide'>
            <h5>How To Play</h5>
            <p id='htpText'>Try to sort the tracks in order of popularity from lowest to highest. The popularity matrix is calculated by Spotify using a number of parameters, including number of streams and how often the track is currently being streamed. A number of points will be granted depending on how close your order is to that of the correct order. The goal is to get the highest number of points possible.</p>
        </div>

        <div>
            <img id='artistImage' src={artistImage} />
        </div>
      </> ) : (null) }
      </div>
    </div>
    
  );

  function handleDragEnd(event) {
    const {active, over} = event;


    if(active.id !== over.id) {
      setLanguages((items) => {
        const activeIndex = items.indexOf(active.id);
        const overIndex = items.indexOf(over.id);

      return arrayMove(items, activeIndex, overIndex);
      });
    };
  };
};